<template>
	<div
		:class="[
			'info-box',
			`info-box--${theme}`,
			`info-box--${valign}`,
			`info-box--${level}`,
			lastChild ? 'info-box--last-child' : ''
		]"
	>
		<div class="info-box__inner">
			<h2 v-if="heading && level == 'primary'" v-html="heading"></h2>
			<h3 v-if="heading && level == 'secondary'" v-html="heading"></h3>

			<p v-if="preamble" class="info-box__preamble" v-html="preamble"></p>
			<p v-if="bodytext" class="info-box__bodytext" v-html="bodytext"></p>

			<div v-if="cta == 'newaccount'" class="info-box__cta">
				<router-link :to="{ name: 'newaccount' }">
					<Button size="small">
						{{ $t('login.createAccountButton') }}
					</Button>
				</router-link>
			</div>

			<p v-if="textLink == 'login'" class="info-box__link">
				{{ $t('login.accountCreatedText') }}
				<router-link :to="{ name: 'login' }">
					{{ $t('login.loginButton') }}
				</router-link>
			</p>
		</div>
	</div>
</template>

<script>
import Button from '../atoms/Button'

export default {
	name: 'InfoBox',
	data: () => {
		return {}
	},
	components: {
		Button
	},
	props: {
		theme: {
			type: String,
			default: 'light'
		},
		valign: {
			type: String,
			default: 'left'
		},
		level: {
			type: String,
			default: 'secondary'
		},
		lastChild: {
			type: Boolean,
			default: false
		},
		heading: {
			type: String,
			default: ''
		},
		preamble: {
			type: String,
			default: ''
		},
		bodytext: {
			type: String,
			default: ''
		},
		cta: {
			type: String,
			default: ''
		},
		textLink: {
			type: String,
			default: ''
		}
	},
	methods: {}
}
</script>

<style scoped lang="scss">
.info-box {
	padding: 35px 30px 20px 30px;
	margin-bottom: 30px;
	box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.1);

	max-width: 350px;
	box-sizing: border-box;
	margin-left: auto;
	margin-right: auto;

	// &--last-child {
	// 	margin-bottom: -60px;
	// }

	h2 {
		color: #434449;
		font-size: 24px;
		font-weight: 400;
		line-height: 1.2;
		margin-bottom: 12px;
	}
	h3 {
		color: #434449;
		font-size: 20px;
		font-weight: 400;
		line-height: 1.2;
		margin-bottom: 15px;
	}
	&__preamble {
		color: #434449;
		font-size: 18px;
		font-weight: 500;
		line-height: 1.35;
		margin-bottom: 40px;
	}
	&__bodytext {
		color: #697791;
		font-size: 12px;
		line-height: 1.5;
		margin-bottom: 10px;
	}
	&__cta {
		margin-top: 23px;
		margin-bottom: 15px;
	}
	&__link {
		color: #697791;
		font-size: 12px;
		line-height: 1.5;
		margin-top: 20px;
		margin-bottom: 10px;
	}

	&--middle {
		padding: 35px 30px 35px 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 200px;
	}

	&--light {
		background: #fff;
		h2,
		h3,
		.info-box__preamble {
			color: #434449;
		}
		.info-box__bodytext,
		.info-box__link {
			color: #697791;
		}
	}
	&--dark {
		background: #697791;
		h2,
		h3,
		.info-box__preamble,
		.info-box__bodytext {
			color: #fff;
		}
	}
	&--secondary {
		padding: 35px 20px 20px 20px;
		text-align: center;
	}

	&--secondary.info-box--light {
		text-align: left;
		h3 {
			font-size: 24px;
			margin-bottom: 12px;
		}
	}

	@media (min-width: 640px) {
		&--last-child {
			margin-bottom: 0;
		}
		&--secondary {
			height: 100%;
		}
		&--primary {
			max-width: 450px;
		}
		&--secondary.info-box--light {
			text-align: center;
			h3 {
				font-size: 20px;
				margin-bottom: 15px;
			}
		}
	}

	@media (min-width: 1024px) {
		height: 100%;
		max-width: 100%;
		margin: 0;

		&--last-child {
			margin-bottom: 0;
		}

		&--middle {
			height: 100%;
		}
	}
}

.empty-state__right-boxes .info-box {
	@media (min-width: 640px) {
		&--primary {
			height: 100%;
		}
	}
	@media (min-width: 1024px) {
		&:not(.info-box--last-child) {
			margin-bottom: 60px;
			height: auto;
		}
	}
}
</style>
